export default {
    methods: {
        poll(fn, interval, timeout) {
            var endTime = Number(new Date()) + (timeout || 60000);
            interval = interval || 30000;

            var checkCondition = async function(resolve, reject) {
                // If the condition is met, we're done! 
                var result = await fn();
                if(result) {
                    resolve(result);
                }
                // If the condition isn't met but the timeout hasn't elapsed, go again
                else if (timeout === undefined || Number(new Date()) < endTime) {
                    setTimeout(checkCondition, interval, resolve, reject);
                }
                // Didn't match and too much time, reject!
                else {
                    reject(new Error('timed out for ' + fn + ': ' + arguments));
                }
            };

            return new Promise(checkCondition);
        },
    },
}